module.exports = __webpack_public_path__ + "media/images/reach-new-customers-0ad3fdf5f875724dd2c8998c5fddb421.png";